import { apiFetch } from './http';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export interface UserMe {
  id: string;
  firstName: string;
  lastName: string | null;
  phone: string;
  email: string | null;
  birthday: string | null;
  bonuses: number;
}

function authHeaders(token: string): HeadersInit {
  return { Authorization: `Bearer ${token}` };
}

function authJsonHeaders(token: string): HeadersInit {
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

export const userProfileApi = {
  async getMe(token: string): Promise<UserMe> {
    const res = await apiFetch(`${API_URL}/users/me`, { headers: authHeaders(token) });
    if (!res.ok) throw new Error('profile');
    const data = await res.json();
    return data.user;
  },

  async patchMe(
    token: string,
    body: { firstName?: string; lastName?: string; email?: string; birthday?: string },
  ): Promise<UserMe> {
    const res = await apiFetch(`${API_URL}/users/me`, {
      method: 'PATCH',
      headers: authJsonHeaders(token),
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const m = data?.message;
      const msg = Array.isArray(m) ? m[0] : typeof m === 'string' ? m : 'Не удалось сохранить';
      throw new Error(msg);
    }
    return data.user;
  },

  async deleteMe(token: string): Promise<void> {
    const res = await apiFetch(`${API_URL}/users/me`, {
      method: 'DELETE',
      headers: authHeaders(token),
    });
    if (!res.ok) throw new Error('delete');
  },
};
